import { render, staticRenderFns } from "./community2.vue?vue&type=template&id=773621e9&scoped=true&"
import script from "./community2.vue?vue&type=script&lang=js&"
export * from "./community2.vue?vue&type=script&lang=js&"
import style0 from "./community2.vue?vue&type=style&index=0&id=773621e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773621e9",
  null
  
)

export default component.exports